import { useEffect } from "react"

import useOnboardContext from "./useOnboardContext"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../util/analytics"
import { useRouter } from "../util/router"

const useCustomOnboardParam = () => {
  const router = useRouter()
  const { setIsCustomOnboarding } = useOnboardContext()

  useEffect(() => {
    if (router.query.src) {
      trackAnalyticEvent(ANALYTIC_EVENTS.CAMPAIGN_REDIRECT, {
        src: router.query.src,
      })
      setIsCustomOnboarding(true)
    }
  }, [router.query.src])
}

export default useCustomOnboardParam
